/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetFutureReservations200ResponseInnerStatus } from './GetFutureReservations200ResponseInnerStatus';
import {
    GetFutureReservations200ResponseInnerStatusFromJSON,
    GetFutureReservations200ResponseInnerStatusFromJSONTyped,
    GetFutureReservations200ResponseInnerStatusToJSON,
    GetFutureReservations200ResponseInnerStatusToJSONTyped,
} from './GetFutureReservations200ResponseInnerStatus';

/**
 * 
 * @export
 * @interface GetFutureReservations200ResponseInner
 */
export interface GetFutureReservations200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    surname: string;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    phoneNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    dateTime: string;
    /**
     * 
     * @type {number}
     * @memberof GetFutureReservations200ResponseInner
     */
    diners: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetFutureReservations200ResponseInner
     */
    tables: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    customerComments?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    id: string;
    /**
     * 
     * @type {GetFutureReservations200ResponseInnerStatus}
     * @memberof GetFutureReservations200ResponseInner
     */
    status: GetFutureReservations200ResponseInnerStatus;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    source: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    zone: string;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    policy: GetFutureReservations200ResponseInnerPolicyEnum;
    /**
     * 
     * @type {number}
     * @memberof GetFutureReservations200ResponseInner
     */
    policyAmount: number;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    endTime: string;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    tabId: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    email: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetFutureReservations200ResponseInner
     */
    rating?: number;
    /**
     * 
     * @type {string}
     * @memberof GetFutureReservations200ResponseInner
     */
    comment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetFutureReservations200ResponseInner
     */
    price?: number;
}


/**
 * @export
 */
export const GetFutureReservations200ResponseInnerPolicyEnum = {
    Card: 'card',
    Deposit: 'deposit',
    None: 'none'
} as const;
export type GetFutureReservations200ResponseInnerPolicyEnum = typeof GetFutureReservations200ResponseInnerPolicyEnum[keyof typeof GetFutureReservations200ResponseInnerPolicyEnum];


/**
 * Check if a given object implements the GetFutureReservations200ResponseInner interface.
 */
export function instanceOfGetFutureReservations200ResponseInner(value: object): value is GetFutureReservations200ResponseInner {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('surname' in value) || value['surname'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('dateTime' in value) || value['dateTime'] === undefined) return false;
    if (!('diners' in value) || value['diners'] === undefined) return false;
    if (!('tables' in value) || value['tables'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('zone' in value) || value['zone'] === undefined) return false;
    if (!('policy' in value) || value['policy'] === undefined) return false;
    if (!('policyAmount' in value) || value['policyAmount'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    if (!('tabId' in value) || value['tabId'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function GetFutureReservations200ResponseInnerFromJSON(json: any): GetFutureReservations200ResponseInner {
    return GetFutureReservations200ResponseInnerFromJSONTyped(json, false);
}

export function GetFutureReservations200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFutureReservations200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'surname': json['surname'],
        'phoneNumber': json['phoneNumber'],
        'dateTime': json['dateTime'],
        'diners': json['diners'],
        'tables': json['tables'],
        'customerComments': json['customerComments'] == null ? undefined : json['customerComments'],
        'id': json['id'],
        'status': GetFutureReservations200ResponseInnerStatusFromJSON(json['status']),
        'source': json['source'],
        'zone': json['zone'],
        'policy': json['policy'],
        'policyAmount': json['policyAmount'],
        'endTime': json['endTime'],
        'tabId': json['tabId'],
        'email': json['email'],
        'rating': json['rating'] == null ? undefined : json['rating'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'price': json['price'] == null ? undefined : json['price'],
    };
}

export function GetFutureReservations200ResponseInnerToJSON(json: any): GetFutureReservations200ResponseInner {
    return GetFutureReservations200ResponseInnerToJSONTyped(json, false);
}

export function GetFutureReservations200ResponseInnerToJSONTyped(value?: GetFutureReservations200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'surname': value['surname'],
        'phoneNumber': value['phoneNumber'],
        'dateTime': value['dateTime'],
        'diners': value['diners'],
        'tables': value['tables'],
        'customerComments': value['customerComments'],
        'id': value['id'],
        'status': GetFutureReservations200ResponseInnerStatusToJSON(value['status']),
        'source': value['source'],
        'zone': value['zone'],
        'policy': value['policy'],
        'policyAmount': value['policyAmount'],
        'endTime': value['endTime'],
        'tabId': value['tabId'],
        'email': value['email'],
        'rating': value['rating'],
        'comment': value['comment'],
        'price': value['price'],
    };
}

